module.exports = __webpack_public_path__ + "img/logo.50f352ad.png";